import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "../button/button.module";
import { StepperComponent } from "./stepper.component";
import { StepperContainerComponent } from "./stepper-container/stepper-container.component";
import { StepperContentComponent } from "./stepper-content/stepper-content.component";
import { StepsDataService } from "./stepsData/steps-data.service";
import { ProgressbarModule } from "../progressbar/progressbar.module";
import { PointModule } from "../point/point.module";
import { StepperStandaloneComponent } from "./stepper-standalone/stepper-standalone.component";

@NgModule({
	declarations: [
		StepperComponent,
		StepperContainerComponent,
		StepperContentComponent,
		StepperStandaloneComponent
	],
	imports: [CommonModule, ProgressbarModule, PointModule, ButtonModule],
	providers: [StepsDataService],
	exports: [
		StepperComponent,
		StepperContainerComponent,
		StepperContentComponent,
		StepperStandaloneComponent
	]
})
export class StepperModule {}
